import { render } from "./SerialNumberUpgrade.vue?vue&type=template&id=daaca7ec&scoped=true"
import script from "./SerialNumberUpgrade.vue?vue&type=script&lang=js"
export * from "./SerialNumberUpgrade.vue?vue&type=script&lang=js"

import "./SerialNumberUpgrade.vue?vue&type=style&index=0&id=daaca7ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daaca7ec"],['__file',"src/views/ProductManage/SerialNumberUpgrade/SerialNumberUpgrade.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "daaca7ec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('daaca7ec', __exports__)) {
    api.reload('daaca7ec', __exports__)
  }
  
  module.hot.accept("./SerialNumberUpgrade.vue?vue&type=template&id=daaca7ec&scoped=true", () => {
    api.rerender('daaca7ec', render)
  })

}


export default __exports__